<template>
  <b-field label="Enter on behalf of dependants">
    <b-select
      v-model="dependant"
      placeholder="Select a dependant"
      @input="$emit('input', dependant)"
    >
      <option
        v-for="dependant in dependants"
        :value="dependant._id"
        :key="dependant._id"
      >
        {{ dependant.firstname }} {{ dependant.surname }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      dependant: this.value
    };
  },
  created() {
    this.getDependants();
  },
  computed: {
    ...mapGetters(["dependants"])
  },
  methods: {
    ...mapActions(["getDependants"])
  }
};
</script>